import { Box } from "@mui/material";
import { Default } from "../../layouts";

const CiceroView = () => {
  return (
    <Default>
      <Box padding={4}>
        <Box
          component="iframe"
          src=""
          sx={{
            width: "80%",
            height: "50rem",
            border: "2px solid grey",
            backgroundColor: "lightgrey",
            marginTop: 4,
          }}
        />
      </Box>
    </Default>
  );
};

export const Cicero = () => <CiceroView />;
export default Cicero;
